module.exports = __webpack_public_path__ + "ff5d6b047f8fcc93c8fdc9de68a92a5e.svg";